var version = "4.0.13";
export { version as default };
//# sourceMappingURL=Version.js.map
